import Box from '../../../components/Box/Box';
import Link from '../../../components/Link/Link';

function NotFoundErrorPageSide(): JSX.Element {
  return (
    <div className='error-page__side'>
      <Box bgColor='lilac'>
        <>
          <h2>Is this what you were looking for?</h2>
          <p>
            <b>Hopefully one of these options might help:</b>
          </p>
          <ul className='error-page__links'>
            <li>
              <Link href='/everyday' displayBlock={true} targetSelf={true}>
                Everyday Account
              </Link>
            </li>
            <li>
              <Link
                href='/special-monthly-interest'
                displayBlock={true}
                targetSelf={true}
              >
                Special Monthly Interest Account
              </Link>
            </li>
            <li>
              <Link href='/smart-saver' displayBlock={true} targetSelf={true}>
                Smart Saver Account
              </Link>
            </li>
            <li>
              <Link
                href='/online-savings'
                displayBlock={true}
                targetSelf={true}
              >
                Online Savings Account
              </Link>
            </li>
            <li>
              <Link href='/term-deposit' displayBlock={true} targetSelf={true}>
                Term Deposit
              </Link>
            </li>
            <li>
              <Link href='/credit-card' displayBlock={true} targetSelf={true}>
                Credit Card
              </Link>
            </li>
          </ul>
        </>
      </Box>
    </div>
  );
}

export default NotFoundErrorPageSide;
